







  import Vue from 'vue'
  import { Component, Prop } from 'nuxt-property-decorator'

  @Component
  export default class OneTab extends Vue {
    name: string = 'OneTab'

    @Prop({
      type: Boolean,
      default: false,
    })
    isActive?: boolean

    @Prop({
      type: String,
      default: '',
    })
    label?: string

    @Prop({
      type: String,
      default: '',
    })
    icon?: string

    get iconClass() {
      return `icon-${this.icon}`
    }

    selectTab() {
      this.$emit('tab-selected')
    }
  }
